import { Directive } from '@angular/core';
import { QuoteFacade } from '../+state/quote.facade';

@Directive()
export abstract class QuoteCreateBaseComponent extends QuoteFacade {
  public text = 'QuoteCreate';

  constructor() {
    super();
  }
}
